import Vue from 'vue'
import VueNoty from 'vuejs-noty'

Vue.use(VueNoty, {
  progressBar: true,
  layout: 'bottomRight',
  theme: 'relax'
})
